import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { getAppVersion } from './util';

const MainApp = require('./MainApp').default;

const hostname = window.location.hostname;

const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

// Ambiente derivado do hostname (nao depende do build):
// hml.sisgasrec... -> staging | sisgasrec... -> production | local
const environment = isLocal
  ? 'local'
  : hostname.startsWith('hml.')
  ? 'staging'
  : 'production';

Sentry.init({
  dsn: 'https://644d5458e11a4e3f8edc4c3b2c4b8d2d@logs.institutototum.com.br/11',
  environment,
  release: getAppVersion(),
  autoSessionTracking: false, // GlitchTip nao suporta sessions
});

// Identifica o usuario nos eventos do GlitchTip (persistido no login).
try {
  const lastEmail = localStorage.getItem('SISGASREC.LAST_EMAIL');
  if (lastEmail) {
    Sentry.setUser({ email: lastEmail });
  }
} catch (e) {
  /* best-effort */
}

const SentryApp = Sentry.withErrorBoundary(MainApp, {
  fallback: ({ error, componentStack }) =>
    isLocal ? (
      <div style={{ padding: 20 }}>
        <h1>Erro no React</h1>
        <pre>{error?.toString()}</pre>
        <pre>{componentStack}</pre>
      </div>
    ) : (
      <p>Something went wrong.</p>
    ),
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});

window.addEventListener('error', (event) => {
  Sentry.captureException(event.error || event);
});

const originalConsoleError = console.error;
console.error = (...args) => {
  Sentry.captureMessage(args.join(' '), 'error');
  originalConsoleError(...args);
};

const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  Sentry.captureMessage(args.join(' '), 'warning');
  originalConsoleWarn(...args);
};

const rootEl = document.getElementById('app-site');

const render = () => {
  ReactDOM.render(<SentryApp />, rootEl);
};

render();

export default SentryApp;
